import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { ICONS } from 'Components/utils/icon/icons';
import { Icon } from 'Components/frameworks/icon/Icon';
import { AlternativePriceTitle } from 'Components/widgets/alternative-proposals/alternative-price-title/AlternativePriceTitle';
type Props = {
  className?: string;
  proposal?: Proposal;
  title: string;
};
export const AlternativeProposalHeader = ({ className, proposal, title }: Props) =>
  proposal ? (
    <AlternativePriceTitle className={className} proposal={proposal} title={title} />
  ) : (
    <h2
      className={classnames(
        'flex items-start gap-10 font-brand text-24 leading-tight text-orange md:text-28 lg:text-32',
        className,
      )}
    >
      <Icon className="shrink-0" hasRtl name={ICONS.LIGHTBULB} width="1em" />
      {title}
    </h2>
  );
